// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* General Container */
.contact-container {
  position: relative;
  display: flex;
  justify-content: flex-start; /* Align text to the left */
  align-items: center;
  padding-top: 90px;
}

/* Left Side Text */
.contact-text {
  width: 100%;
  height: 50vh; /* Ensure it takes full viewport height */
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background-color: #212529;
  margin-bottom: 300px;
  padding-left: 140px;
}

.confidentiality {
  margin-top: 20px;
  font-size: 16px;
  font-weight: bold;
  color: green;
}

/* Right Side Contact Form - Positioned Absolutely */
.contact-form {
  position: absolute;
  top: 55%; /* Adjust this to position form as needed */
  right: 6%;
  transform: translateY(-50%);
  background: #F8F9FA;
  padding: 50px;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
  max-width: 500px;
  width: 100%;
}

.contact-form input,
.contact-form textarea {
  width: 100%;
  padding: 12px;
  margin: 10px 0;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 14px;
}

.contact-form textarea {
  height: 80px;
}

.contact-form button {
  width: 100%;
  background: #007bff;
  color: white;
  padding: 12px;
  border: none;
  font-size: 16px;
  border-radius: 5px;
  cursor: pointer;
  margin-top: 10px;
}

.contact-form button:hover {
  background: #0056b3;
}

.contact-bold-text-style---- {
  font-size: 36px;
  font-weight: 700;
  color: #ffffff;
  font-family: "Plus Jakarta Sans", serif;
  text-align: left;
  margin-bottom: 30px;
}

.text-parent-container-style {
  display: flex;
  justify-content: 'flex-start';
  text-align: left;
}

.contact-form-modal-bold-text-style {
  font-size: 30px;
  font-weight: 400;
  color: #212529;
  font-family: "Plus Jakarta Sans", serif;
  text-align: left;
  margin-bottom: 20px;
}

.contact-form-modal-light-text-style {
  font-size: 22px;
  font-weight: 500;
  color: #212529;
  font-family: "Plus Jakarta Sans", serif;
  text-align: left;
  margin-bottom: 20px;
}

.submit-button-view {
  width: 50%;
}


.text-parent-light-container-style {
  display: flex;
  justify-content: 'flex-start';
  text-align: left;
  max-width: 620px;
  margin-bottom: 30px;
}

.contact-light-text-style{
  font-size: 18px;
  font-weight: 500;
  color: #ffffff;
  font-family: "Plus Jakarta Sans", serif;
  text-align: left;
}

.contact-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #F8F9FA;
  padding: 15px 40px;
  border-radius: 10px;
  margin-top: 40px;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  border: 1px solid #ddd;
  margin-bottom: 32px;
}

.address,
.contact-numbers {
  font-size: 14px;
  color: #333;
}

.contact-form-verified-icon {
  height: 53px;
  width: 40px;
  margin-right: 10px;
}

.contact-form-verified-text-view {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  bottom: 130px;
  left: 300px
}


/* Responsive Design */
@media (max-width: 768px) {
  .contact-container {
    flex-direction: column;
    padding: 20px;
  }

  .contact-text {
    padding-right: 0;
    text-align: left;
  }

  .contact-form {
    position: relative;
    right: 0;
    top: 0;
    transform: none;
    margin-top: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/ContactForm/contactForm.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,aAAa;EACb,2BAA2B,EAAE,2BAA2B;EACxD,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,mBAAmB;AACnB;EACE,WAAW;EACX,YAAY,EAAE,yCAAyC;EACvD,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,YAAY;AACd;;AAEA,oDAAoD;AACpD;EACE,kBAAkB;EAClB,QAAQ,EAAE,2CAA2C;EACrD,SAAS;EACT,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,gBAAgB;EAChB,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uCAAuC;EACvC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uCAAuC;EACvC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uCAAuC;EACvC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;;AAGA;EACE,aAAa;EACb,6BAA6B;EAC7B,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb;AACF;;;AAGA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,MAAM;IACN,eAAe;IACf,gBAAgB;EAClB;AACF","sourcesContent":["/* General Container */\n.contact-container {\n  position: relative;\n  display: flex;\n  justify-content: flex-start; /* Align text to the left */\n  align-items: center;\n  padding-top: 90px;\n}\n\n/* Left Side Text */\n.contact-text {\n  width: 100%;\n  height: 50vh; /* Ensure it takes full viewport height */\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  background-color: #212529;\n  margin-bottom: 300px;\n  padding-left: 140px;\n}\n\n.confidentiality {\n  margin-top: 20px;\n  font-size: 16px;\n  font-weight: bold;\n  color: green;\n}\n\n/* Right Side Contact Form - Positioned Absolutely */\n.contact-form {\n  position: absolute;\n  top: 55%; /* Adjust this to position form as needed */\n  right: 6%;\n  transform: translateY(-50%);\n  background: #F8F9FA;\n  padding: 50px;\n  border-radius: 10px;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);\n  max-width: 500px;\n  width: 100%;\n}\n\n.contact-form input,\n.contact-form textarea {\n  width: 100%;\n  padding: 12px;\n  margin: 10px 0;\n  border: 1px solid #ddd;\n  border-radius: 5px;\n  font-size: 14px;\n}\n\n.contact-form textarea {\n  height: 80px;\n}\n\n.contact-form button {\n  width: 100%;\n  background: #007bff;\n  color: white;\n  padding: 12px;\n  border: none;\n  font-size: 16px;\n  border-radius: 5px;\n  cursor: pointer;\n  margin-top: 10px;\n}\n\n.contact-form button:hover {\n  background: #0056b3;\n}\n\n.contact-bold-text-style---- {\n  font-size: 36px;\n  font-weight: 700;\n  color: #ffffff;\n  font-family: \"Plus Jakarta Sans\", serif;\n  text-align: left;\n  margin-bottom: 30px;\n}\n\n.text-parent-container-style {\n  display: flex;\n  justify-content: 'flex-start';\n  text-align: left;\n}\n\n.contact-form-modal-bold-text-style {\n  font-size: 30px;\n  font-weight: 400;\n  color: #212529;\n  font-family: \"Plus Jakarta Sans\", serif;\n  text-align: left;\n  margin-bottom: 20px;\n}\n\n.contact-form-modal-light-text-style {\n  font-size: 22px;\n  font-weight: 500;\n  color: #212529;\n  font-family: \"Plus Jakarta Sans\", serif;\n  text-align: left;\n  margin-bottom: 20px;\n}\n\n.submit-button-view {\n  width: 50%;\n}\n\n\n.text-parent-light-container-style {\n  display: flex;\n  justify-content: 'flex-start';\n  text-align: left;\n  max-width: 620px;\n  margin-bottom: 30px;\n}\n\n.contact-light-text-style{\n  font-size: 18px;\n  font-weight: 500;\n  color: #ffffff;\n  font-family: \"Plus Jakarta Sans\", serif;\n  text-align: left;\n}\n\n.contact-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: #F8F9FA;\n  padding: 15px 40px;\n  border-radius: 10px;\n  margin-top: 40px;\n  max-width: 1200px;\n  margin-left: auto;\n  margin-right: auto;\n  border: 1px solid #ddd;\n  margin-bottom: 32px;\n}\n\n.address,\n.contact-numbers {\n  font-size: 14px;\n  color: #333;\n}\n\n.contact-form-verified-icon {\n  height: 53px;\n  width: 40px;\n  margin-right: 10px;\n}\n\n.contact-form-verified-text-view {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  bottom: 130px;\n  left: 300px\n}\n\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .contact-container {\n    flex-direction: column;\n    padding: 20px;\n  }\n\n  .contact-text {\n    padding-right: 0;\n    text-align: left;\n  }\n\n  .contact-form {\n    position: relative;\n    right: 0;\n    top: 0;\n    transform: none;\n    margin-top: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
